export enum TransactionType {
  'solo' = 'solo',
  'peak_off_peak' = 'peak_off_peak',
  'base' = 'base',
  'spread' = 'spread',
  'physical_block' = 'physical_block',
}
